import React, { useState, useCallback } from "react";
import { LOADER_IMG } from "@whatslly/commons/constants";
import styles from "./loading-chat-overlay.module.scss";
import { AsyncImage } from "@whatslly/ui-components/AsyncImage";

export const LoadingChatOverlay = React.memo(({ children }: { children: React.ReactNode }) => {
  const [isTextVisible, setIsTextVisible] = useState(false);
  const handleContainerAnimationEnd = useCallback((event: React.AnimationEvent<HTMLDivElement>) => {
    if (event.animationName.includes("loadingContainerFadeIn")) {
      setIsTextVisible(true);
    }
  }, []);

  const loadingClassName = isTextVisible ? `${styles.loading} ${styles.loadingTextVisible}` : styles.loading;

  return (
    <div id="whatsly-dlp-overlay" className={styles.blockWapChatWrapper} data-testid="block-message-overlay" data-show="true">
      <div className={styles.container}>
        <div data-loader="true" className={loadingClassName} onAnimationEnd={handleContainerAnimationEnd}>
          <AsyncImage alt="tuvis loader" src={LOADER_IMG} />
          <p className={styles.loadingText}>{children}</p>
        </div>
      </div>
    </div>
  );
});
